// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"6843a622","104":"a745c39c","706":"a68d4584","787":"62e6c0a6","826":"3db4c59e"}[chunkId] + ".chunk.js";
};